<template>
    <div id="quote">
        <!-- type="primary" -->
        <v-alert dense border="bottom" type="red" icon="mdi-information">
            EEG Close Case
            <div style="float: right">
                <!-- <v-btn
                    color="grey lighten-5"
                    rounded
                    small
                    class="mb-1 text--primary"
                    @click="add_close()"
                    v-if="team_name == 'ODM'"
                >
                    <v-icon color="primary">mdi-plus</v-icon>
                    <span>Create xxx</span>
                </v-btn> -->
            </div>
        </v-alert>

        <v-row class="mar-t-25">
            <v-col cols="12">
                <v-card-title class="text-h5"> Travel Zone </v-card-title>
            </v-col>
        </v-row>
        <v-row class="mar-t-25">
            <v-col cols="6" md="3">
                <v-dialog
                    ref="dialog"
                    v-model="modal_date1"
                    :return-value.sync="date_time.date1"
                    persistent
                    width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="date_time.date1"
                            label="Service Start Date time"
                            prepend-icon=""
                            readonly
                            v-on="on"
                            outlined
                            dense
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="date_time.date1" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal_date1 = false"
                            >Cancel</v-btn
                        >
                        <v-btn
                            text
                            color="primary"
                            @click="
                                func_add_date(1),
                                    $refs.dialog.save(date_time.date1)
                            "
                            >OK</v-btn
                        >
                    </v-date-picker>
                </v-dialog>
            </v-col>
            <v-col cols="6" md="3">
                <v-text-field
                    v-model="date_time.hour1"
                    dense
                    outlined
                    label="Hour"
                    :rules="hour1R"
                    maxlength="2"
                    @input="func_add_date(1)"
                ></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
                <v-text-field
                    v-model="date_time.minute1"
                    dense
                    outlined
                    label="Minute"
                    :rules="minute1R"
                    maxlength="2"
                    @input="func_add_date(1)"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row class="mar-t-30">
            <v-col cols="6" md="3">
                <v-dialog
                    ref="dialog2"
                    v-model="modal_date2"
                    :return-value.sync="date_time.date2"
                    persistent
                    width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="date_time.date2"
                            label="Service END Date time"
                            prepend-icon=""
                            readonly
                            v-on="on"
                            outlined
                            dense
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="date_time.date2" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal_date2 = false"
                            >Cancel</v-btn
                        >
                        <v-btn
                            text
                            color="primary"
                            @click="
                                func_add_date(2),
                                    $refs.dialog2.save(date_time.date2)
                            "
                            >OK</v-btn
                        >
                    </v-date-picker>
                </v-dialog>
            </v-col>
            <v-col cols="6" md="3">
                <v-text-field
                    v-model="date_time.hour2"
                    dense
                    outlined
                    label="Hour"
                    :rules="hour2R"
                    maxlength="2"
                    @input="func_add_date(2)"
                ></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
                <v-text-field
                    v-model="date_time.minute2"
                    dense
                    outlined
                    label="Minute"
                    :rules="minute2R"
                    maxlength="2"
                    @input="func_add_date(2)"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row class="mar-t-30">
            <v-col cols="6" md="3">
                <v-text-field
                    v-model="date_time.date3"
                    dense
                    outlined
                    label="Service Fixed Date time"
                    maxlength="2"
                    disabled
                ></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
                <v-text-field
                    v-model="date_time.hour3"
                    dense
                    outlined
                    label="Hour"
                    maxlength="2"
                    disabled
                ></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
                <v-text-field
                    v-model="date_time.minute3"
                    dense
                    outlined
                    label="Minute"
                    maxlength="2"
                    disabled
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row class="mar-t-30">
            <v-col cols="6" md="3">
                <v-text-field
                    v-model="
                        form.CaseExchange.Resolution.Repair.TimeLog[0].LaborType
                    "
                    dense
                    outlined
                    label="Labor Type"
                    disabled
                ></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
                <v-text-field
                    v-model="
                        form.CaseExchange.Resolution.Repair.TimeLog[0].Duration
                    "
                    dense
                    outlined
                    label="Duration (mins)"
                    maxlength="2"
                    :rules="[
                        (v) => /^\d+$/.test(v) || 'Duration (mins) be a number',
                    ]"
                    disabled
                ></v-text-field>
                <!-- Travel Zone start - end = Duration (mins) -->
            </v-col>
        </v-row>
        <v-row class="mar-t-30">
            <v-col cols="6" md="3">
                <v-text-field
                    v-model="
                        form.CaseExchange.Resolution.Repair.TimeLog[1].LaborType
                    "
                    dense
                    outlined
                    label="Labor Type"
                    disabled
                ></v-text-field>
            </v-col>
            <v-col cols="6" md="3">
                <v-text-field
                    v-model="
                        form.CaseExchange.Resolution.Repair.TimeLog[1].Duration
                    "
                    dense
                    outlined
                    label="Duration (mins)"
                    maxlength="2"
                    :rules="[
                        (v) => /^\d+$/.test(v) || 'Duration (mins) be a number',
                    ]"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row class="mar-t-25">
            <v-col cols="12">
                <v-card-title class="text-h5">
                    Resolution Notes/Diagnostics
                </v-card-title>
            </v-col>
            <v-col cols="12" class="mar-t-30">
                <v-textarea
                    v-model="form.CaseExchange.Resolution.ResolutionNotes"
                    label="Resolution Notes/Diagnostics"
                    rows="4"
                ></v-textarea>
            </v-col>
        </v-row>

        <v-row
            class="mar-t-25"
            v-for="(r_part, i_part) in data_main.parts"
            :key="i_part"
        >
            <v-col cols="3">
                <v-card-title class="text-h5">
                    Line No : {{ r_part.ponumber_line }}
                </v-card-title>
            </v-col>
            <v-col cols="5">
                <v-card-title class="text-h5">
                    Part Order :
                    {{ r_part.ponumber + " " + r_part.part_name }}</v-card-title
                >
            </v-col>
            <v-col cols="4">
                <v-card-title class="text-h5">
                    {{ r_part.part_description }}
                </v-card-title>
            </v-col>

            <!-- <v-col cols="6" md="4" lg="3" class="mar-t-30">
                <v-text-field dense outlined label="Logistics Order Number">
                </v-text-field>
            </v-col>
            <v-col cols="6" md="4" lg="3" class="mar-t-30">
                <v-text-field dense outlined label="Part Status">
                </v-text-field>
            </v-col> -->
            <v-col cols="6" md="4" lg="3" class="mar-t-30">
                <v-autocomplete
                    dense
                    outlined
                    menu-props="auto"
                    label="Usage Code"
                    :items="usage_code"
                    v-model="r_part.usage_code"
                    @input="func_failure_code_statte(i_part, r_part.usage_code)"
                ></v-autocomplete>
            </v-col>
            <v-col cols="6" md="4" lg="3" class="mar-t-30">
                <v-autocomplete
                    disabled
                    dense
                    outlined
                    menu-props="auto"
                    label="Failure Code"
                    v-model="r_part.failure_code"
                    :items="failure_code_statte"
                ></v-autocomplete>
            </v-col>
            <v-col
                cols="6"
                md="4"
                lg="3"
                class="mar-t-30"
                v-if="r_part.failure_code == '55 - DOA'"
            >
                <v-autocomplete
                    :items="statte_ddditional"
                    dense
                    outlined
                    label="Additional Failure Code"
                    v-model="r_part.Add_Failure_Code"
                >
                </v-autocomplete>
            </v-col>
            <!-- <v-col cols="6" md="4" lg="3" class="mar-t-30">
                <v-text-field
                    dense
                    outlined
                    label="Installed Part Numbe"
                    v-model="r_part.InstalledPartNumber"
                >
                </v-text-field>
            </v-col>

            <v-col cols="6" md="4" lg="3" class="mar-t-30">
                <v-text-field
                    dense
                    outlined
                    label="Removed Part Number"
                    v-model="r_part.RemovedPartNumber"
                >
                </v-text-field>
            </v-col> -->
            <v-col cols="6" md="4" lg="3" class="mar-t-30">
                <v-text-field
                    dense
                    outlined
                    label="Install Serial Number (CT-NEW)"
                    v-model="r_part.ct_new"
                >
                </v-text-field>
            </v-col>
            <v-col cols="6" md="4" lg="3" class="mar-t-30">
                <v-text-field
                    dense
                    outlined
                    label="Removed Serial Number (CT-OLD) "
                    v-model="r_part.ct_old"
                >
                </v-text-field>
            </v-col>

            <v-col cols="6" md="4" lg="3" class="mar-t-30">
                <!-- <v-radio-group
                    class="mar-t-03"
                    v-model="r_part.return_override_flag"
                    :rules="return_flagR1"
                    required
                    row
                >
                    <v-radio label="No" value="No"></v-radio>
                    <v-radio label="Yes" value="Yes"></v-radio>
                </v-radio-group> -->
                <v-autocomplete
                    dense
                    outlined
                    menu-props="auto"
                    label="Return Override Flag"
                    :items="['Yes', 'No']"
                    v-model="r_part.return_override_flag"
                    :rules="return_flagR1"
                ></v-autocomplete>
            </v-col>
            <v-col cols="6" md="4" lg="3" class="mar-t-30">
                <v-autocomplete
                    v-if="r_part.return_override_flag == 'Yes'"
                    dense
                    outlined
                    menu-props="auto"
                    label="Return Override Reason"
                    :items="[
                        'Customer buy back defective',
                        'DMR entitlement coverage',
                        'Special HP Approval',
                    ]"
                    v-model="r_part.return_override_reason"
                    :rules="return_flagR2"
                ></v-autocomplete>
            </v-col>
        </v-row>

        <v-row class="mar-t-20">
            <v-col cols="12">
                <v-card-title class="text-h5"> Request to Close </v-card-title>
            </v-col>
            <v-col cols="6" md="3" class="mar-t-25">
                <v-autocomplete
                    dense
                    outlined
                    menu-props="auto"
                    label="Repair Class Code"
                    :items="repair_code"
                    v-model="form.CaseExchange.Resolution.Repair.RepairClass"
                ></v-autocomplete>
            </v-col>
            <v-col cols="6" md="3" class="mar-t-25">
                <v-autocomplete
                    dense
                    outlined
                    menu-props="auto"
                    label="Delay Codes"
                    :items="delay_code"
                    v-model="form.CaseExchange.Resolution.Repair.DelayCode"
                ></v-autocomplete>
            </v-col>
        </v-row>

        <v-row
            class="mar-t-20"
            v-if="
                form.CaseExchange.Resolution.Repair.RepairClass ==
                    'AO - Align or Adjust Only' &&
                    detailcase.product_group == 'Computing'
            "
        >
            <v-col cols="12">
                <v-card-title class="text-h5"> NMU </v-card-title>
            </v-col>
            <v-col cols="4" md="3" class="mar-t-25">
                <v-autocomplete
                    dense
                    outlined
                    menu-props="auto"
                    label="Primary"
                    :items="primary_item"
                    v-model="nmu.primary"
                    @input="func_primary(1)"
                ></v-autocomplete>
            </v-col>
            <v-col cols="4" md="3" class="mar-t-25">
                <v-autocomplete
                    dense
                    outlined
                    menu-props="auto"
                    label="Secondary"
                    :items="secondary_item"
                    v-model="nmu.secondary"
                    :disabled="secondary_item.length == 0"
                    @input="func_primary(2)"
                ></v-autocomplete>
            </v-col>
            <v-col cols="4" md="3" class="mar-t-25">
                <v-autocomplete
                    dense
                    outlined
                    menu-props="auto"
                    label="Resolution Note (Auto Capture)"
                    :items="resolution_item"
                    v-model="nmu.resolution"
                    :disabled="resolution_item.length == 0"
                ></v-autocomplete>
            </v-col>

            <v-col
                cols="4"
                md="3"
                class="mar-t-25"
                v-if="this.nmu.secondary == 'Type Version'"
            >
                <v-text-field
                    @input="func_primary()"
                    label="Type Version Manually"
                    dense
                    outlined
                    v-model="nmu.version"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row class="mar-t-20" v-if="detailcase.return_override_flag">
            <v-col cols="12">
                <v-card-title class="text-h5">
                    Return Override Flag
                </v-card-title>
            </v-col>
            <v-col cols="12" md="3" class="mar-t-30">
                <v-radio-group
                    class="mar-t-03"
                    v-model="data_main.return_override_flag"
                    required
                    row
                >
                    <v-radio label="Yes" value="Yes"></v-radio>
                    <v-radio label="No" value="No"></v-radio>
                </v-radio-group>
            </v-col>
            <v-col
                cols="12"
                class="mar-t-15"
                v-if="data_main.return_override_flag == 'No'"
            >
                <v-autocomplete
                    dense
                    outlined
                    menu-props="auto"
                    label="Return Override Reason"
                    :items="[
                        'Customer buy back defective',
                        'DMR entitlement coverage',
                        'Special HP Approval',
                    ]"
                    v-model="data_main.return_override_reason"
                    @input="func_primary(1)"
                ></v-autocomplete>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="10" md="4" lg="3">
                <v-btn
                    block
                    color="success"
                    @click="cal_base64()"
                    :disabled="
                        form.CaseExchange.Resolution.Repair.RepairClass ==
                            null ||
                            form.CaseExchange.Resolution.Repair.DelayCode ==
                                null
                    "
                >
                    SAVE CLOSE CASE EEG
                </v-btn>
            </v-col>
        </v-row>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios"

let url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    props: ["detailcase"],
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
        console.log(this.detailcase.parts, "-main detailcase")
        this.data_main = this.detailcase
    },
    beforeUpdate() {},
    mounted() {
        this.check_data()
    },
    methods: {
        func_failure_code_statte(idx, st) {
            if (st == "SAUS-Used + Not Consumed") {
                this.data_main.parts[idx].failure_code = "55 - DOA"
            } else if (st == "SAUN-Unused") {
                this.data_main.parts[idx].failure_code = "72 - Returned good"
            } else if (st == "SAUS-Used + Consumed") {
                this.data_main.parts[idx].failure_code = "73 - Used & Consumed"
            }

            let countP = 0
            let countP2 = 0

            this.data_main.parts.map((r, i) => {
                console.log(r.failure_code)
                if (r.failure_code == "73 - Used & Consumed") {
                    countP++
                } else if (r.failure_code == "72 - Returned good") {
                    countP2++
                }
            })

            if (countP > 0) {
                this.form.CaseExchange.Resolution.Repair.RepairClass =
                    "CO - Rpr,Compt,Parts Repl"
                this.ResolutionNotes = ""
                this.nmu = {
                    primary: null,
                    secondary: null,
                    resolution: null,
                    version: "",
                }
                this.form.CaseExchange.Resolution.ResolutionNotes =
                    this.data_main.text_closecase + "/" + localStorage.fullname
            } else if (countP2 == this.data_main.parts.length) {
                this.form.CaseExchange.Resolution.Repair.RepairClass =
                    "AO - Align or Adjust Only"
                this.nmu.primary = this.data_main.nmu_primary
                this.nmu.secondary = this.data_main.nmu_secondary
                this.nmu.resolution = this.data_main.nmu_resolution
                this.nmu.version = this.data_main.nmu_version

                if (this.nmu.resolution != "") {
                    this.ResolutionNotes = this.form.CaseExchange.Resolution.ResolutionNotes
                    this.form.CaseExchange.Resolution.ResolutionNotes =
                        this.form.CaseExchange.Resolution.ResolutionNotes +
                        "/" +
                        this.nmu.resolution +
                        " " +
                        this.nmu.version
                }
            }
        },
        check_data() {
            let sub = this.data_main.subcase - 1

            this.form.CaseExchange.WorkOrder[0].WorkOrderID = this.data_main.wonumber
            this.form.CaseExchange.WorkOrder[0].BookingDetails.SubkTechName = this.data_main.subs[
                sub
            ].engineer_name
            this.form.CaseExchange.WorkOrder[0].BookingDetails.SubkLearnerID = this.data_main.subs[
                sub
            ].engineer_hp_learnerid
            this.form.CaseExchange.Resolution.ResolutionNotes =
                this.data_main.text_closecase + "/" + localStorage.fullname

            this.form.CaseExchange.WorkOrder[0].PartnerStatusDateTime = this.cal_date_eegX(
                "main",
                ""
            )

            let d1 = this.data_main.actual_arrival_time.split(" ")
            // let d1 = this.data_main.actual_arrival_time_x.split(" ")
            let t1 = d1[1].split(":")
            let d2 = this.data_main.booking_end_time.split(" ")
            let t2 = d2[1].split(":")

            this.date_time.date1 = d1[0]
            this.date_time.hour1 = t1[0]
            this.date_time.minute1 = t1[1]
            this.date_time.date2 = d2[0]
            this.date_time.hour2 = t2[0]
            this.date_time.minute2 = t2[1]
            this.date_time.date3 = d2[0]
            this.date_time.hour3 = t2[0]
            this.date_time.minute3 = t2[1]

            let countP = 0
            let countP2 = 0
            this.data_main.parts.map((r, i) => {
                if (r.ce_status == "Bad") {
                    this.data_main.parts[i].usage_code = "SAUS-Used + Consumed"
                    this.data_main.parts[i].failure_code =
                        "73 - Used & Consumed"
                    countP++
                } else if (r.ce_status == "Good") {
                    this.data_main.parts[i].usage_code = "SAUN-Unused"
                    this.data_main.parts[i].failure_code = "72 - Returned good"
                    countP2++
                } else if (r.ce_status == "DOA") {
                    this.data_main.parts[i].usage_code =
                        "SAUS-Used + Not Consumed"
                    this.data_main.parts[i].failure_code = "55 - DOA"
                }
            })

            if (countP > 0) {
                this.form.CaseExchange.Resolution.Repair.RepairClass =
                    "CO - Rpr,Compt,Parts Repl"
                this.nmu = {
                    primary: null,
                    secondary: null,
                    resolution: null,
                    version: "",
                }
            } else if (countP2 == this.data_main.parts.length) {
                this.form.CaseExchange.Resolution.Repair.RepairClass =
                    "AO - Align or Adjust Only"

                this.nmu.primary = this.data_main.nmu_primary
                this.nmu.secondary = this.data_main.nmu_secondary
                this.nmu.resolution = this.data_main.nmu_resolution
                this.nmu.version = this.data_main.nmu_version

                this.secondary_item = [this.data_main.nmu_secondary]
                this.resolution_item = [this.data_main.nmu_resolution]

                if (this.nmu.resolution != "") {
                    this.ResolutionNotes = this.form.CaseExchange.Resolution.ResolutionNotes
                    this.form.CaseExchange.Resolution.ResolutionNotes =
                        this.form.CaseExchange.Resolution.ResolutionNotes +
                        "/" +
                        this.nmu.resolution +
                        " " +
                        this.nmu.version
                }
            }
            // console.log(this.nmu)
            // console.log(this.data_main)
            // console.log(this.data_main) / this.func_add_date(1)

            this.func_add_date(1)
            this.func_add_date(2)
            this.func_add_date(3)
        },

        func_add_date(row) {
            if (row == 1) {
                this.form.CaseExchange.Resolution.Repair.ServiceStartDateTime =
                    this.date_time.date1 +
                    "T" +
                    this.date_time.hour1 +
                    ":" +
                    this.date_time.minute1 +
                    ":00"
                this.date_time.date2 = this.date_time.date1
                this.modal_date1 = false
            } else if (row == 2) {
                this.form.CaseExchange.Resolution.Repair.ServiceEndDateTime =
                    this.date_time.date2 +
                    "T" +
                    this.date_time.hour2 +
                    ":" +
                    this.date_time.minute2 +
                    ":00"

                this.form.CaseExchange.Resolution.Repair.SystemFixedTime =
                    this.date_time.date2 +
                    "T" +
                    this.date_time.hour2 +
                    ":" +
                    this.date_time.minute2 +
                    ":00"

                this.date_time.date1 = this.date_time.date2
                this.date_time.date3 = this.date_time.date2
                this.date_time.hour3 = this.date_time.hour2
                this.date_time.minute3 = this.date_time.minute2

                this.modal_date2 = false
            } else if (row == 3) {
                let x = this.date_time.hour2 - this.date_time.hour1
                let y = this.date_time.minute2 - this.date_time.minute1
                let z = (x > 0 ? x * 60 : 0) + y
                // if (z > 60) {
                //     z / 60
                // } else {
                //     let zz = "00:" + z
                // }
                return "00:" + z
            }
        },
        cal_base64() {
            this.dialog_loading = true
            const pdf2base64 = require("pdf-to-base64")
            pdf2base64(
                `https://api.aittservice.com/api/hpi/download-cso/${this.data_main.subcase_id}`
            )
                .then((response) => {
                    this.form.CaseExchange.Attachment.FileContent = response
                    this.dialog_loading = false
                    this.save_eeg()
                })
                .catch((error) => {
                    console.log(error) //Exepection error....
                })
        },
        async save_eeg() {
            this.dialog_loading = true
            let datax
            if (this.data_main.parts.length > 0) {
                this.data_main.parts.map((r, i) => {
                    this.eeg_part.push({
                        LineNumber: parseInt(r.ponumber_line),
                        PartOrderNumber: r.ponumber,
                        InstalledSerialNumber: r.ct_new,
                        RemovedSerialNumber: r.ct_old,
                        UsageCode: r.usage_code,
                        FailureCode: r.failure_code,
                        InstalledPartDescription: null,
                        InstalledPartNumber: r.InstalledPartNumber,
                        RemovedPartNumber: r.part_name,
                        // RemovedPartNumber: r.RemovedPartNumber ? r.RemovedPartNumber : null,
                        RemovedPartDescription: null,
                        AdditionalFailureCode: r.Add_Failure_Code,
                        ReturnOverrideReason: null,
                        InstalledPartNumber: r.part_name,
                        // InstalledPartNumber: null,
                        FailureAnalysisFlag: "Yes",
                        ReturnOverrideFlag: r.return_override_flag
                            ? r.return_override_flag
                            : "",
                        ReturnOverrideReason: r.return_override_reason
                            ? r.return_override_reason
                            : "",
                    })
                })
                this.form.CaseExchange.Resolution.Repair.RepairPart = this.eeg_part
            } else {
            }

            this.form.CaseExchange.Attachment.FileName =
                this.data_main.case_id + ".pdf"
            this.form.CaseExchange.Resolution.Repair.SystemProductNumber = this.data_main.customer_product_no
            this.form.CaseExchange.Resolution.Repair.ProductNumber = this.data_main.customer_product_no
            this.form.CaseExchange.Resolution.Repair.SystemSerialNumber = this.data_main.product_serial
            this.form.CaseExchange.Resolution.Repair.SerialNumber = this.data_main.product_serial
            this.form.CaseExchange.Resolution.Repair.SystemDownDuration = this.func_add_date(
                3
            )

            datax = {
                maincase_id: this.data_main.maincase_id,
                subcase_id: this.data_main.subcase_id,
                status: 20,
                project_name: this.data_main.project_name,
                eeg: this.form,
            }

            console.log(datax, "DATA SAVE TO EEG")

            await axios
                .post(url + "engineer/save-scheduled-status", datax, this.tk)
                .then((response) => {
                    console.log(response)
                    if (response.data.message === "update - complete") {
                        this.ResolutionNotes = ""
                        this.form.CaseExchange.Resolution.ResolutionNotes = ""
                        console.log(response, "-res data")
                        this.dialog_loading = false
                        this.$emit("closecase-eeg-click")
                        this.$swal("บันทึกรายการสำเร็จ", {
                            icon: "success",
                            button: false,
                            timer: 2000,
                        })
                    } else {
                        this.dialog_loading = false
                        this.$swal("WO Closed wrong! Please try again.", {
                            icon: "warning",
                            button: true,
                            // timer: 2000,
                        })
                    }
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        func_primary(st) {
            // console.log(this.nmu, "-this.nmu")
            if (st == 1) {
                this.secondary_item = []
                this.resolution_item = []
                this.nmu.secondary = ""
                this.nmu.resolution = ""
                this.nmu.version = ""
            }

            if (this.nmu.primary == "CMOS Reset") {
                this.secondary_item = ["Win+V", "CMOS battery"]

                if (this.nmu.secondary == "Win+V") {
                    this.nmu.resolution = "CMOS Reset -Win+V"
                    this.resolution_item = ["CMOS Reset -Win+V"]
                } else if (this.nmu.secondary == "CMOS battery") {
                    this.nmu.resolution = "CMOS Reset -CMOS battery"
                    this.resolution_item = ["CMOS Reset -CMOS battery"]
                }
            } else if (this.nmu.primary == "BIOS recovery (Win+B)") {
                this.secondary_item = ["---"]
                this.resolution_item = ["BIOS recovery (Win+B)"]
                this.nmu.secondary = "---"
                this.nmu.resolution = "BIOS recovery (Win+B)"
            } else if (
                this.nmu.primary == "Thermal Paste Heat sink clean and Refix"
            ) {
                this.secondary_item = ["---"]
                this.resolution_item = [
                    "Thermal Paste Heat sink clean and Refix",
                ]
                this.nmu.secondary = "---"
                this.nmu.resolution = "Thermal Paste Heat sink clean and Refix"
            } else if (this.nmu.primary == "Reseating of cables /Connectors") {
                this.secondary_item = [
                    "DC-IN CABLE",
                    "HDD CABLE",
                    "LCD DISPLAY CABLE",
                    "Webcam Cable",
                    "WLAN cable",
                    "WWAN Cable",
                    "CMOS battery Cable",
                    "Touchpad cable",
                    "Power Board cable",
                    "Antenna cable",
                    "Keyboard cable",
                    "USB Board Cable",
                    "Audio Board cable",
                    "Battery cable",
                    "Smart card reader Board cable",
                    "Fan cable",
                ]

                if (this.nmu.secondary == "DC-IN CABLE") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - DC-IN CABLE"
                } else if (this.nmu.secondary == "HDD CABLE") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  -  HDD CABLE"
                } else if (this.nmu.secondary == "LCD DISPLAY CABLE") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - LCD DISPLAY CABLE"
                } else if (this.nmu.secondary == "Webcam Cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - Webcam Cable"
                } else if (this.nmu.secondary == "WLAN cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - WLAN cable"
                } else if (this.nmu.secondary == "WWAN Cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - WWAN Cable"
                } else if (this.nmu.secondary == "CMOS battery Cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - CMOS battery Cable"
                } else if (this.nmu.secondary == "Touchpad cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - Touchpad cable"
                } else if (this.nmu.secondary == "Power Board cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - Power Board cable"
                } else if (this.nmu.secondary == "Antenna cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - Antenna cable"
                } else if (this.nmu.secondary == "Keyboard cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - Keyboard cable"
                } else if (this.nmu.secondary == "USB Board Cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - USB Board Cable"
                } else if (this.nmu.secondary == "Audio Board cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - Audio Board cable"
                } else if (this.nmu.secondary == "Battery cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - Audio Battery cable"
                } else if (
                    this.nmu.secondary == "Smart card reader Board cable"
                ) {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - Smart card reader Board cable"
                } else if (this.nmu.secondary == "Fan cable") {
                    this.nmu.resolution =
                        "Reseating of cables /Connectors  - Fan cable"
                }
                this.resolution_item = [this.nmu.resolution]
            } else if (this.nmu.primary == "Memory Reseat") {
                this.secondary_item = ["---"]
                this.resolution_item = ["Memory Reseat"]
                this.nmu.secondary = "---"
                this.nmu.resolution = "Memory Reseat"
            } else if (this.nmu.primary == "cleaning of memory Slot") {
                this.secondary_item = ["---"]
                this.resolution_item = ["cleaning of memory Slot"]
                this.nmu.secondary = "---"
                this.nmu.resolution = "cleaning of memory Slot"
            } else if (this.nmu.primary == "OS Restore") {
                this.secondary_item = ["---"]
                this.resolution_item = ["OS Restore"]
                this.nmu.secondary = "---"
                this.nmu.resolution = "OS Restore"
            } else if (this.nmu.primary == "BOOT from custom USB drive") {
                this.secondary_item = ["---"]
                this.resolution_item = ["BOOT from custom USB drive"]
                this.nmu.secondary = "---"
                this.nmu.resolution = "BOOT from custom USB drive"
            } else if (this.nmu.primary == "Windows settings/reinstall") {
                this.secondary_item = ["---"]
                this.resolution_item = ["Windows settings/reinstall"]
                this.nmu.secondary = "---"
                this.nmu.resolution = "Windows settings/reinstall"
            } else if (this.nmu.primary == "Power Drain") {
                this.secondary_item = ["---"]
                this.resolution_item = ["Power Drain"]
                this.nmu.secondary = "---"
                this.nmu.resolution = "Power Drain"
            } else if (this.nmu.primary == "BIOS Update") {
                this.secondary_item = ["Type Version"]
                this.resolution_item = ["BIOS Update -"]
                this.nmu.secondary = "Type Version"
                this.nmu.resolution = "BIOS Update -"
            } else if (this.nmu.primary == "Driver Update") {
                this.secondary_item = ["Type Version"]
                this.resolution_item = ["Driver Update -"]
                this.nmu.secondary = "Type Version"
                this.nmu.resolution = "Driver Update -"
            } else if (this.nmu.primary == "Firmware Update") {
                this.secondary_item = ["Type Version"]
                this.resolution_item = ["Firmware Update -"]
                this.nmu.secondary = "Type Version"
                this.nmu.resolution = "Firmware Update -"
            }
            if (this.nmu.resolution != "") {
                if (this.ResolutionNotes == "") {
                    this.ResolutionNotes = this.form.CaseExchange.Resolution.ResolutionNotes
                    this.form.CaseExchange.Resolution.ResolutionNotes =
                        this.form.CaseExchange.Resolution.ResolutionNotes +
                        "/" +
                        this.nmu.resolution
                } else {
                    this.form.CaseExchange.Resolution.ResolutionNotes =
                        this.ResolutionNotes +
                        "/" +
                        this.nmu.resolution +
                        " " +
                        this.nmu.version
                }
            }
        },

        cal_date_eegX(st1, st2) {
            let date = new Date()
            var h = date.getHours()
            var m = date.getMinutes()
            var s = date.getSeconds()
            let year = date.toLocaleString("default", {
                year: "numeric",
            })
            let month = date.toLocaleString("default", {
                month: "2-digit",
            })
            let day = date.toLocaleString("default", { day: "2-digit" })

            if (st1 == "main") {
                let dateD = `${year}-${month}-${day}T${h}:${m}:${s}Z`
                let myArray = dateD.split(" ")
                let arr1 =
                    myArray.length == 1
                        ? myArray[0].split("-")
                        : myArray[1].split("-")
                let formattedDate =
                    myArray.length == 1
                        ? dateD
                        : `${arr1[0] - 543}-${arr1[1]}-${arr1[2]}`

                return formattedDate
            }
        },
    },
    data() {
        return {
            ResolutionNotes: "",
            eeg_part: [],
            emp_id: localStorage.emp_img,
            team_name: localStorage.team_name,
            tk: null,
            data_main: [],
            dialog_loading: false,
            modal_date1: false,
            modal_date2: false,
            date_time: {
                date1: null,
                date2: null,
                date3: null,
                hour1: "00",
                minute1: "00",
                hour2: "00",
                minute2: "00",
                hour3: "00",
                minute3: "00",
            },
            hour1R: [
                (v) => !!v || "Hour is required",
                (v) => /^\d+$/.test(v) || "Hour be a number",
            ],
            minute1R: [
                (v) => !!v || "minute is required",
                (v) => /^\d+$/.test(v) || "minute be a number",
            ],
            hour2R: [
                (v) => !!v || "Hour is required",
                (v) => /^\d+$/.test(v) || "Hour be a number",
            ],
            minute2R: [
                (v) => !!v || "minute is required",
                (v) => /^\d+$/.test(v) || "minute be a number",
            ],
            return_flagR1: [(v) => !!v || "Return Status is required"],
            return_flagR2: [(v) => !!v || "Return Val is required"],
            form: {
                CaseExchange: {
                    EventType: "PartnerUpdates",
                    EventSubType: "Updates",
                    Originator: "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
                    IncomingChannel: "EEG",
                    WorkOrder: [
                        {
                            WorkOrderID: "",
                            PartnerName: "APJ_Acacia_P",
                            PartnerStatus: "Problem Resolution",
                            PartnerStatusDateTime: null,
                            BookingDetails: {
                                SubkTechName: null,
                                SubkLearnerID: null,
                            },
                        },
                    ],
                    Resolution: {
                        TravelZone: "01",
                        ResolutionNotes: null,
                        Repair: {
                            RepairClass: null,
                            DelayCode: null,
                            ServiceStartDateTime: null,
                            ServiceEndDateTime: null,
                            SystemProductNumber: null,
                            SystemSerialNumber: null,
                            SystemFixedTime: null,
                            SystemDownDuration: null,
                            ProductNumber: null,
                            SerialNumber: null,

                            Usage: {
                                UsageUnit: "0",
                                UsageQuantity: "0",
                                MonoCount: "0",
                                ColorCount: "0",
                                TotalCount: "0",
                            },

                            TimeLog: [
                                {
                                    LaborType: "Hardware Repair/Installation",
                                    Duration: "30",
                                    OutsideOfBusinessHours: "YES",
                                },
                                {
                                    LaborType: "Travel",
                                    Duration: "30",
                                    OutsideOfBusinessHours: "YES",
                                },
                            ],
                        },
                    },
                    Notes: {
                        NotesDescription: "$#WO Closed#$",
                        ExternallyVisible: "Yes",
                    },
                    Attachment: {
                        FileType: "application/pdf",
                        FileName: null,
                        FileContent: null,
                    },
                },
            },
            repair_code: [
                "AO - Align or Adjust Only",
                "AS - ADP Onsite Repair",
                "CA - Courier Assisted Service",
                "CD - Cust Declined SN",
                "CO - Rpr,Compt,Parts Repl",
                "CP - Alternative Supplied Part Replaced",
                "IN - Installation",
                "ND - Not Defined",
                "PP - Customer Self-Repair",
                "PM - Preventative Maint",
                "SN - Service Note",
                "SV - Service Center Repair",
                "SW - Software Support",
                "WK - Workmanship",
                // "AA - Accnt Mgmt Activity",
                // "AB - ADP Bench Repair",
                // "AR - Associated Repair",
                // "AU - Site Audits",
                //
                // "DG - Remote Support Maintenance",
                // "DO - Documentation",
                // "HE - Hands and Eyes",
                // "HM - Relocation Services",
                // "IR - Incomplete Repair",
                // "MT - Meetings",
                // "NR - HP-not recommd SN",
                // "NS - Network Start Up",
                // "NT - No Trouble Found",
                // "PA - Phone Assistance",
                // "PO - Parts Only",
                // "SC - Subcontracted Repair",
                // "SP - Site Planning/Prep",
                // "UC - User Caused",
                // "ZZ – MPS Device Replaced",
            ],
            failure_code_statte: [
                "55 - DOA",
                "72 - Returned good",
                "73 - Used & Consumed",
            ],
            delay_code: [
                "0-Response Met",
                "1-Returned to office for resource",
                "2-Parts Issue",
                "3-No CE Resources Available",
                "4-Subcase Sent to wrong CE",
                "5-Travel Delay",
                "6-No Trained/Qualified CE Available",
                "7-Subcase recd late from Call Center",
                "8-Customer caused Delay",
                "9-Other",
                "12-Inaccurate diagnose by customer action",
            ],
            usage_code: [
                "SAUN-Unused",
                "SAUS-Used + Consumed",
                "SAUS-Used + Not Consumed",
                // "TRAN-Transferred",
            ],
            statte_ddditional: [
                "Branding (mother board and formatters only)",
                "Customer Cancelled",
                "Damaged out of the box",
                "Functionally failed when inserted",
                "MS - Miss Shipment",
                "Ordered by CE opened",
                "Ordered by CE unopened",
                "PD - Physically Damaged",
                "PM - Part Missing",
                "Proactive Replacement",
                "Reactive Replacement",
                "Recomended by DBD opened",
                "Recomended by DBD unopened",
                "WP - Wrong Part in Box",
            ],
            nmu: {
                primary: null,
                secondary: null,
                resolution: null,
                version: "",
            },
            primary_item: [
                "CMOS Reset",
                "BIOS recovery (Win+B)",
                "Thermal Paste Heat sink clean and Refix",
                "Reseating of cables /Connectors",
                "Memory Reseat",
                "cleaning of memory Slot",
                "OS Restore",
                "BOOT from custom USB drive",
                "Windows settings/reinstall",
                "Power Drain",
                "BIOS Update",
                "Driver Update",
                "Firmware Update",
            ],
            secondary_item: [],
            resolution_item: [],
        }
    },
}
</script>
<style scoped>
.aa-01 {
    background-color: rgb(92, 157, 253) !important;
}
.aa-02 {
    margin-right: 40px;
    font-weight: bold !important;
    font-size: 20px;
    color: #ffff;
}
.bb-01 {
    background-color: rgb(209, 221, 223) !important;
}
.bb-02 {
    margin-right: 40px;
    font-weight: bold !important;
    font-size: 20px;
    color: rgb(30, 85, 122);
}
.bb-03 {
    /* margin-right: 40px; */
    font-weight: bold !important;
    font-size: 17px;
    color: rgb(30, 85, 122);
}
#printDiv {
    display: none;
}
</style>
